import { render, staticRenderFns } from "./PriorityChip.vue?vue&type=template&id=7e809292"
import script from "./PriorityChip.vue?vue&type=script&lang=js"
export * from "./PriorityChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports